export const appName = 'd2d';
